import { useContext, useEffect, useState } from "react"
import classNames from "./styles.module.scss"
import User from '../../../shared/icons/user.svg'
import { sendMetricContacts } from "../../../shared/MetricApi"
import { UserContext } from "../../../App"
import Exit from '../../../shared/icons/exitCross.svg'
import { useSelector } from "react-redux"

export const GetContact = (props: { opened: boolean | string, setContactState: Function }) => {

  const [opened, setOpened] = useState<boolean | string>(false)
  const [input, setInput] = useState<string>('')
  const [name, setName] = useState<string>('')
  const idInContainer = useSelector((state: any) => (state?.containerUser?.user?.id));


  useEffect(() => {
    setOpened(props.opened)
    //@ts-ignore
    if (typeof (props.opened.valueOf()) === "string") setName(props.opened.valueOf())
    else setName('')
  }, [props.opened])

  useEffect(() => {
    if (opened) window.addEventListener("click", close)
    else window.removeEventListener("click", close)
    function close(e: MouseEvent) {
      //@ts-ignore
      if (!e.target?.classList.contains('GetContact')) {
        props.setContactState(false)
        window.removeEventListener("click", close)
      }
    }
    // eslint-disable-next-line
  }, [opened])


  function send() {
    // console.log(user, id)
    idInContainer && sendMetricContacts(idInContainer, input, 'FiasGeocoded', 'Геокодированный ФИАС')

    //@ts-ignore
    document.getElementById('contP') && (document.getElementById('contP').style.display = 'none')
    //@ts-ignore
    document.getElementById('contDiv') && (document.getElementById('contDiv').style.display = 'none')
    //@ts-ignore
    document.getElementById('thanks') && (document.getElementById('thanks').style.display = 'flex')
    setTimeout(() => {
      //@ts-ignore
      document.getElementById('thanks') && (document.getElementById('thanks').style.display = 'none')

      props.setContactState(false)
    }, 2000);
  }

  return <>{
    opened && <div className={classNames.contact + ' GetContact'}>
      <img id="exitPopup" className={classNames.cross} alt="close icon" src={Exit} onClick={() => props.setContactState(false)} />
      <div id="thanks" className={classNames.thanks + ' GetContact'}>Мы с вами свяжемся!</div>
      <p id='contP' className={classNames.contactTitle + ' GetContact'}>Отчет по территории <br />{name ? name : ''}</p>
      <div id='contDiv' className={classNames.formContainer + ' GetContact'}>
        <p className="GetContact">Оставьте свои контакты, мы свяжемся с вами</p>

        <div className={classNames.inputContainer + ' GetContact'}>
          <input className={classNames.input + ' GetContact'} onChange={(e) => setInput(e.target.value)} placeholder="Почта или телефон" />
          <img src={User} className={classNames.user + ' GetContact'} alt="user icon" />
        </div>

        <div className={classNames.send + ' ' + ((input.length < 1) ? classNames.nonactive : '') + ' GetContact'} onClick={() => input.length > 0 && send()}> <p className="GetContact">Запросить отчет</p> </div>
      </div>
    </div>}
  </>

}